import Category from "./Category";
import TourCard from "./TourCard";
import TourTab from "./TourTab";
export default function TabsContainer({ tours, getInfo, setLoading }) {
  return (
    <>
      {/* first tab */}
      <div
        className="tab-pane fade show active"
        id="first-id"
        role="tabpanel"
        aria-labelledby="first-id-tab"
      >
        <TourTab
        setLoading={setLoading}
          tours={tours.filter((value) => value.main_status == 0)}
          canNew
          getInfo={getInfo}
        />
      </div>
      {/* second tab */}
      <div
        className="tab-pane fade"
        id="second-id"
        role="tabpanel"
        aria-labelledby="second-id-tab"
      >
        <TourTab
        setLoading={setLoading}
          tours={tours.filter((value) => value.main_status == 4)}
          getInfo={getInfo}
        />
      </div>
      {/* third tab */}
      <div
        className="tab-pane fade"
        id="third-id"
        role="tabpanel"
        aria-labelledby="third-id-tab"
      >
        <TourTab
        setLoading={setLoading}
          tours={tours.filter((value) => value.main_status == 1)}
          getInfo={getInfo}
        />
      </div>
      {/* fourth tab */}
      <div
        className="tab-pane fade"
        id="fourth-id"
        role="tabpanel"
        aria-labelledby="fourth-id-tab"
      >
        <TourTab
        setLoading={setLoading}
          tours={tours.filter((value) => value.main_status == 2)}
          getInfo={getInfo}
        />
      </div>
      {/* fifth tab */}
      <div
        className="tab-pane fade"
        id="fifth-id"
        role="tabpanel"
        aria-labelledby="fifth-id-tab"
      >
        <TourTab
          tours={tours.filter((value) => value.main_status == 3)}
          getInfo={getInfo}
        />
      </div>
      <div className="tab-pane fade w-100" id="sixth-id">
        <div className="w-100 d-flex flex-column align-items-center">
          <Category />
        </div>
      </div>
    </>
  );
}
